import { useEffect } from 'react';
import _find from 'lodash/find';

import { useReactNodeView } from '@lyearn/lygo-core';
import { Uppy, UppyFile } from '@lyearn/shared/hooks/useUppy';

import { isRemoteUrl, throwIfError, validatedSrc } from '../utils/upload';
import useHandleUpload from './useHandleUpload';
import useUpload from './useUpload';

const EMPTY_OBJECT: Record<string, string> = {};

const useUploadRemoteMedia = (
  uppy: Uppy | null,
  currentFile: ReturnType<typeof useUpload>['currentFile'],
  node?: ReturnType<typeof useReactNodeView>['node'],
) => {
  const { src, id } = node?.attrs || EMPTY_OBJECT;
  const handleUpload = useHandleUpload();

  useEffect(() => {
    const isUploading = currentFile?.id;

    if (!validatedSrc(src) || isUploading || !isRemoteUrl(src)) {
      return;
    }

    const urlPlugin = uppy?.getPlugin('Url');

    if (urlPlugin) {
      handleUpload(
        urlPlugin
          // @ts-ignore
          .addFile(src)
          .then(throwIfError)
          .then(() => {
            const addedFile = _find(uppy?.getFiles(), { remote: { body: { url: src } } }) as
              | UppyFile
              | undefined;

            addedFile && uppy?.setFileMeta(addedFile.id, { shortId: id });
          }),
      );
    }
  }, [currentFile, handleUpload, id, src, uppy]);
};

export default useUploadRemoteMedia;
